"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const MiniProviderContent_styles_1 = require("./MiniProviderContent.styles");
const useProviderContent_1 = require("../common/util/useProviderContent");
const constants_1 = require("../common/util/constants");
const ProviderName = ({ provider, availability, location, config = {}, viewProviderUrl, onViewProvider, viewProviderLinkTarget, intl, isProfileDisabled }) => {
    const { id, name } = (0, useProviderContent_1.useProviderContent)({
        provider,
        availability,
        location,
        config
    });
    if (isProfileDisabled || viewProviderUrl == null)
        return (react_1.default.createElement(MiniProviderContent_styles_1.ProviderNameContainer, { id: `mini-provider-name-${id}`, "data-testid": `mini-provider-name-${id}` }, name));
    return (react_1.default.createElement(MiniProviderContent_styles_1.ProviderNameLinkContainer, { "data-testid": `mini-provider-content-link-${id}`, rel: "noopener noreferrer", target: viewProviderLinkTarget, href: viewProviderUrl, onClick: onViewProvider, draggable: false, "aria-label": intl.formatMessage(constants_1.messages.ariaProviderProfile, {
            name
        }) }, name));
};
exports.default = (0, intl_1.injectIntl)(ProviderName);
//# sourceMappingURL=ProviderName.js.map